import { DOCUMENT, Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Partner } from 'src/app/config/partner/_default';
import { PartnerConfig } from 'src/app/core/interfaces/partner-config';
import { versionCookieValue } from 'src/app/shared/components/version-switch/version-cookie';

/**
 * Turns the router's in-app navigation into an area into a full page load while the area's version cookie says
 * `new`, so the host's redirect, which only sees full page loads, sends it to the same page in the new frontend. The
 * first navigation came with a full page load the redirect has already answered; loading it again would loop wherever
 * the host has no redirect.
 */
export function newFrontendGuard(cookieOf: (partner: PartnerConfig) => PartnerConfig['bankingVersionCookie']): CanActivateFn {
  return (_route, state) => {
    const document = inject(DOCUMENT);
    const cookie = cookieOf(Partner);
    if (!inject(Router).navigated || !cookie || versionCookieValue(document.cookie, cookie.name) !== 'new') {
      return true;
    }
    document.location.assign(inject(Location).prepareExternalUrl(state.url));
    return false;
  };
}

export const newBankingGuard = newFrontendGuard(partner => partner.bankingVersionCookie);
